/* PRT 01D shared runtime.
   PRT.addToCart(variantId, qty) → POST /cart/add.js, then fetch /cart.js and dispatch
   `prt:cart:updated` on document (detail = cart JSON). The header listens to update the count
   and open its cart drawer. Any element with [data-pd-add="<variantId>"] gets quick-add on click. */
(function(){
  if (window.PRT && window.PRT.__v) return;
  var PRT = window.PRT = window.PRT || {};
  PRT.__v = 1;
  PRT.money = function(cents){
    var v = (Math.round(cents)/100).toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');
    return (v[1] === '00' ? whole : whole + ',' + v[1]) + '\u00a0€';
  };
  var toastEl, toastT;
  PRT.toast = function(msg){
    if (!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'pd-toast'; toastEl.setAttribute('role','status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg class="pd-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span></span>';
    toastEl.querySelector('span').textContent = msg;
    requestAnimationFrame(function(){ toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 2600);
  };
  PRT.refreshCart = function(open){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(cart){
      document.dispatchEvent(new CustomEvent('prt:cart:updated', {detail:{cart:cart, open:!!open}}));
      return cart;
    });
  };
  PRT.addToCart = function(variantId, qty, opts){
    opts = opts || {};
    return fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(variantId), quantity:qty||1}]})
    }).then(function(r){
      return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Greška'); return j; });
    }).then(function(){
      return PRT.refreshCart(opts.open !== false);
    });
  };
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-pd-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    PRT.addToCart(b.getAttribute('data-pd-add'), 1).then(function(){
      b.classList.remove('is-busy'); b.classList.add('is-done');
      PRT.toast('Dodano u košaricu');
      setTimeout(function(){ b.classList.remove('is-done'); }, 1600);
    }).catch(function(err){
      b.classList.remove('is-busy');
      PRT.toast(err.message || 'Nije dodano. Pokušaj ponovno.');
    });
  });
})();
